window.FLASHCARD_DATA = [
  {
    "question": "What is the wellness practice of 'grounding' or 'earthing'?",
    "answer": "It involves walking barefoot outdoors or lying on the ground to realign oneself with the electric charge of the Earth."
  },
  {
    "question": "According to grounding proponents, what is the charge of the Earth's surface?",
    "answer": "The surface of the Earth is slightly negatively charged."
  },
  {
    "question": "What particles do grounding proponents claim flow from the Earth into the body?",
    "answer": "They claim that electrons, which are negatively charged, flow into the body."
  },
  {
    "question": "In the context of electricity, how does physicist Karen Livesey describe 'grounding'?",
    "answer": "It is when you connect an object with an excess charge to the Earth so that the charges equalize."
  },
  {
    "question": "What is the typical outcome for an object's charge density after being electrically grounded?",
    "answer": "The object ends up with the same charge density that the Earth has."
  },
  {
    "question": "Physicist Karen Livesey states that while negative charges from the Earth could theoretically penetrate the body, excess charge typically remains where?",
    "answer": "Excess charge typically remains on the surface of the body."
  },
  {
    "question": "What is the term for the study of the interaction between electromagnetic fields and biological entities?",
    "answer": "Bioelectromagnetics, also known as bioelectromagnetism."
  },
  {
    "question": "A key claim of grounding is that electrons from the Earth can neutralize _____, the reactive molecules that cause cell damage.",
    "answer": "free radicals"
  },
  {
    "question": "Why does Prof. Judy de Haan find the claim that electrons neutralize free radicals to be a 'vague concept'?",
    "answer": "Not all free radicals are charged particles, so neutralizing something uncharged doesn't always make sense."
  },
  {
    "question": "Prof. Judy de Haan warns that in some instances, the addition of electrons could exacerbate what?",
    "answer": "Oxidative stress and cellular damage."
  },
  {
    "question": "What is a key feature of well-designed clinical trials that reduces bias, which Prof. de Haan says is lacking in grounding studies?",
    "answer": "Double blinding, where both the researcher and the patient are unaware of the treatment."
  },
  {
    "question": "The current from a person sleeping on grounding bedsheets was found to be 10 nanoamps, which is over _____ times smaller than the current drawn by household appliances.",
    "answer": "1 billion"
  },
  {
    "question": "What is one area where grounding proponents and scientific experts agree regarding health benefits?",
    "answer": "There is solid evidence that spending time in nature is good for physical and mental health."
  },
  {
    "question": "Research led by Prof. Thomas Astell-Burt found that people in leafier neighborhoods have a lower risk of what conditions?",
    "answer": "Heart disease, diabetes, high blood pressure, psychological distress, loneliness, sleep insufficiency, and dementia."
  },
  {
    "question": "What is the term for the study of how electric and magnetic fields interact with the human body?",
    "answer": "Bioelectromagnetics."
  },
  {
    "question": "The modern pursuit of scientific evidence for grounding's impact on human physiology began in the 1990s with Drs. Karol and Pawel Sokal in Poland and _____ in the United States.",
    "answer": "Clint Ober"
  },
  {
    "question": "One critique of the movie 'The Earthing Movie' is its heavy reliance on _____, which are personal stories that are not a substitute for rigorous scientific evidence.",
    "answer": "anecdotal evidence"
  },
  {
    "question": "A critique of 'The Earthing Movie' points out that suggesting Scarlet fever can be cured by being buried in the ground is dangerous because Scarlet fever is a _____ infection that requires antibiotics.",
    "answer": "bacterial"
  },
  {
    "question": "The critique of 'The Earthing Movie' identifies the _____ fallacy in the argument that because grounding is 'natural,' it must be beneficial.",
    "answer": "appeal to nature"
  },
  {
    "question": "A 2012 systematic review of grounding research published in the Journal of Environmental and Public Health found what about the majority of studies?",
    "answer": "They had significant methodological flaws."
  },
  {
    "question": "What is the scientific consensus, according to the World Health Organization, on the health risks of low-level electromagnetic fields (EMFs)?",
    "answer": "To date, there is no evidence to conclude that exposure to low-level electromagnetic fields is harmful to human health."
  },
  {
    "question": "In a 2015 study, 1 hour of contact with the Earth was found to improve what, more than relaxation alone?",
    "answer": "Pleasant and positive moods."
  },
  {
    "question": "What is OSHA Standard 29 CFR 1910 Subpart S primarily concerned with?",
    "answer": "Safety requirements for electrical systems in workplaces, mandating protective measures like insulating mats."
  },
  {
    "question": "Which US safety standard focuses on protecting workers from arc flashes and electrical shock hazards, supporting the use of insulating mats?",
    "answer": "NFPA 70E (National Fire Protection Association)."
  },
  {
    "question": "The Indian standard IS 15652:2006 for insulating mats classifies them into three types: Class A (up to 3.3 kV), Class B (up to 11 kV), and Class C (above _____).",
    "answer": "11 kV"
  },
  {
    "question": "What is the global safety standard that specifies performance requirements and testing for insulating mats used in electrical installations worldwide?",
    "answer": "IEC 61111:2009."
  },
  {
    "question": "The ASTM D178 safety standard for insulating mats, set by the American Society for Testing and Materials, classifies mats into five classes from 0 to 4, permitting working voltages from 1 kV up to what maximum voltage?",
    "answer": "36 kV."
  },
  {
    "question": "What is a critical safety precaution before working on any grounding or earthing system to prevent accidental energization?",
    "answer": "The electrical circuit or equipment must be isolated, often using lockout/tagout procedures."
  },
  {
    "question": "A 2015 study on grounding after moderate eccentric contractions aimed to reduce what condition?",
    "answer": "Delayed-onset muscle soreness (DOMS)."
  },
  {
    "question": "In the 2015 muscle damage study, what was the proposed mechanism for how electrons from the earth could assist in the healing process?",
    "answer": "Electrons could act as antioxidants to help neutralize rogue reactive oxygen species (ROS)."
  },
  {
    "question": "In a 2022 study on rats, the earthing mat was found to reduce stress-induced behavioral changes and the expression of what two immunoreactivities in the brain?",
    "answer": "c-Fos and CRF (corticotrophin-releasing factor)."
  },
  {
    "question": "A 2022 pilot study suggested that grounding the body improves sleep quality in patients with what condition?",
    "answer": "Mild Alzheimer’s Disease."
  },
  {
    "question": "A 2013 study on 'Earthing (Grounding) the Human Body' reported a reduction in _____, a major factor in cardiovascular disease.",
    "answer": "blood viscosity"
  },
  {
    "question": "What does a critique of 'The Earthing Movie' call the claim that not being grounded is the cause of all inflammation?",
    "answer": "A gross oversimplification of complex biological processes."
  },
  {
    "question": "The critique of 'The Earthing Movie' argues that it's impossible to rule out the _____ without double-blind, placebo-controlled studies.",
    "answer": "placebo effect"
  },
  {
    "question": "Personal Protective Equipment (PPE) for grounding work includes safety helmets, goggles, ear protection, safety boots, and what else to prevent electrical shocks?",
    "answer": "Gloves."
  },
  {
    "question": "What is the term for short-lived electrical events that occur in neurons, muscle cells, and endocrine cells to facilitate communication?",
    "answer": "Action potentials."
  },
  {
    "question": "What is the primary effect of the interaction between microwave-frequency electromagnetic fields and biological systems?",
    "answer": "The production of heat."
  },
  {
    "question": "According to the Wikipedia article, Soviet research in the 1960s and 70s claimed that _____ exposure to microwaves results in more pronounced biologic effects than steady irradiation.",
    "answer": "intermittent"
  },
  {
    "question": "Soviet research claimed that biologic effects of low-intensity microwaves (less than 1 mW/cm^2) became more severe with increasing ____ of work.",
    "answer": "duration"
  },
  {
    "question": "What is the name of the modality, developed by Arsene d'Arsonval, that uses field-induced hyperthermia in the treatment of cancer?",
    "answer": "Diathermy."
  },
  {
    "question": "A 2017 study found that electrical grounding improves _____ in preterm infants.",
    "answer": "vagal tone"
  },
  {
    "question": "What is the term for the logical fallacy of assuming that because one event followed another, the first event caused the second?",
    "answer": "Post hoc ergo propter hoc."
  },
  {
    "question": "The 'Grooni Earthing' article claims that earthing reduces inflammation by providing the body with negatively charged electrons that neutralize positively charged _____.",
    "answer": "free radicals"
  },
  {
    "question": "A 2019 study published in Electromagnetic Biology and Medicine investigated the _____ of non-ionizing electromagnetic fields.",
    "answer": "genetic effects"
  },
  {
    "question": "The Ion Cyclotron Resonance (ICR) hypothesis in bioelectromagnetics suggests the possibility of biological interaction of what type of electromagnetic fields?",
    "answer": "Low-intensity extremely-low frequency (ELF) and static EMF."
  },
  {
    "question": "What is the name for the therapeutic application of a strong, changing magnetic field to induce electrical currents in the brain?",
    "answer": "Transcranial magnetic stimulation (TMS)."
  },
  {
    "question": "Which OSHA standard specifically requires the use of insulating tools and protective equipment, including electrical insulating rubber mats?",
    "answer": "OSHA Standard 29 CFR 1910.335(a)(1)(i)."
  },
  {
    "question": "According to the 'Duratufproducts' article, what must be done regularly to ensure the effectiveness of an earthing system?",
    "answer": "The ground resistance must be tested."
  },
  {
    "question": "What is a common critique of the scientific papers published on the wellness practice of grounding?",
    "answer": "They are noted for a 'lack of scientific rigour', with small sample sizes and poor study design."
  },
  {
    "question": "What insulating material in modern shoes is said by grounding proponents to block the flow of electrons from the Earth?",
    "answer": "Rubber or synthetic soles."
  },
  {
    "question": "What natural mechanism does the body possess for dealing with oxidative stress, according to Prof. Judy de Haan?",
    "answer": "Antioxidant enzymes."
  },
  {
    "question": "In the 2015 study on muscle damage, grounding was associated with a significant increase in what type of white blood cell on day 2 post-exercise?",
    "answer": "Neutrophils."
  },
  {
    "question": "What blood component involved in the immune response was found to be at significantly higher levels in grounded subjects on days 2, 3, and 4 in the 2015 muscle damage study?",
    "answer": "Platelets."
  },
  {
    "question": "What is the term for highly reactive entities with an unpaired electron that can damage cellular components like DNA?",
    "answer": "Free radicals or Reactive Oxygen Species (ROS)."
  },
  {
    "question": "The Earthing Institute claims that inflammation is caused by free radicals, and that free radicals are neutralized by _____ from any source.",
    "answer": "electrons"
  },
  {
    "question": "The British Standard for insulating mats, BS EN 61111, is similar to which global standard?",
    "answer": "IEC 61111:2009."
  },
  {
    "question": "What does the 'Q Recycling & Construction Services' article state is the purpose of wearing safety goggles during grounding work?",
    "answer": "To shield the eyes from dust, debris, and sparks."
  },
  {
    "question": "Luigi Galvani coined what term to describe the phenomenon of muscle activation by electricity in a dissected frog?",
    "answer": "Animal electricity."
  },
  {
    "question": "What is the primary purpose of an electrical insulating mat in a workplace?",
    "answer": "To reduce the risk of electrical accidents by creating a non-conductive surface to stand on."
  },
  {
    "question": "A 2022 study on rats suggested that an earthing mat may improve stress-related responses via the regulation of the _____ system.",
    "answer": "corticotropinergic"
  },
  {
    "question": "According to 'The Guardian' article, what is one alternative to walking barefoot for people who want to practice grounding?",
    "answer": "Using conductive items like mats or sheets plugged into the grounding sockets of electrical outlets."
  },
  {
    "question": "A 2019 study investigated the effectiveness of _____ on recovery after intensive eccentric muscle loading.",
    "answer": "grounded sleeping"
  },
  {
    "question": "A 2014 study claimed that grounding the human body improves the regulation of what?",
    "answer": "Facial blood flow."
  },
  {
    "question": "A 2004 study measured diurnal secretion levels of what hormone to test the hypothesis that grounding during sleep can cause quantifiable changes?",
    "answer": "Cortisol."
  },
  {
    "question": "What is the term for a logical fallacy where a person's belief in a treatment's effectiveness can cause perceived improvements?",
    "answer": "The placebo effect."
  },
  {
    "question": "A 2025 study listed by the Earthing Institute investigated the effects of earthing on _____ function, specifically ATP production and ROS generation.",
    "answer": "mitochondrial"
  },
  {
    "question": "The critique of 'The Earthing Movie' notes that the documentary uses scientific terms like 'free radicals' and 'neutrophils' to lend credibility, but often _____ these concepts.",
    "answer": "misrepresents"
  },
  {
    "question": "According to the Wikipedia article, who coined the term 'bioelectromagnetics' in 1978?",
    "answer": "Thomas C. Rozzell of the Office of Naval Research."
  },
  {
    "question": "The ASTM D178 standard specifies a working voltage of up to _____ for a Class 2 insulating mat.",
    "answer": "17,000 volts"
  },
  {
    "question": "According to Prof. Thomas Astell-Burt, what is the bare minimum landcover of parkland and tree canopy needed to observe consistent health benefits?",
    "answer": "30%."
  },
  {
    "question": "Besides direct barefoot contact, how can one achieve 'earthing' according to the Grooni Earthing article?",
    "answer": "By using earthing products such as sheets, mats, and bands designed to conduct the earth's energy."
  },
  {
    "question": "What does the 'Grooni Earthing' article state about the scientific community's stance on earthing?",
    "answer": "It is finding a common ground, with hundreds of case studies providing evidence of benefits."
  },
  {
    "question": "According to a 2015 NIH article, external therapies like stretching, acupuncture, and ultrasound have proven of _____ value in reducing pain and improving healing from DOMS.",
    "answer": "little or no"
  }
];